import Immutable from 'immutable';
import { combineReducers } from 'redux-immutablejs';

import createDefaultEntitiesReducer from './DefaultEntitiesReducer';

export default combineReducers(
  Immutable.Map({
    users: createDefaultEntitiesReducer('users'),
    accounts: createDefaultEntitiesReducer('accounts'),
    bibs: createDefaultEntitiesReducer('bibs'),
    availabilities: createDefaultEntitiesReducer('availabilities'),
    bibItems: createDefaultEntitiesReducer('bibItems'),
    subscriptions: createDefaultEntitiesReducer('subscriptions'),
    catalogBibs: createDefaultEntitiesReducer('catalogBibs'),
    borrowingHistory: createDefaultEntitiesReducer('borrowingHistory'),
    holds: createDefaultEntitiesReducer('holds'),
    checkouts: createDefaultEntitiesReducer('checkouts'),
    fines: createDefaultEntitiesReducer('fines'),
    interlibraryLoans: createDefaultEntitiesReducer('interlibraryLoans'),
    messages: createDefaultEntitiesReducer('messages'),
    shelves: createDefaultEntitiesReducer('shelves'),
    sites: createDefaultEntitiesReducer('sites'),
    libraries: createDefaultEntitiesReducer('libraries'),
    featuredContent: createDefaultEntitiesReducer('featuredContent'),
    systemMessages: createDefaultEntitiesReducer('systemMessages'),
    ugc: createDefaultEntitiesReducer('ugc'),
    features: createDefaultEntitiesReducer('features'),
    authorNotes: createDefaultEntitiesReducer('authorNotes'),
    authorSuggestions: createDefaultEntitiesReducer('authorSuggestions'),
    relatedAuthors: createDefaultEntitiesReducer('relatedAuthors'),
    reviews: createDefaultEntitiesReducer('reviews'),
    recommendations: createDefaultEntitiesReducer('recommendations'),
    lists: createDefaultEntitiesReducer('lists'),
    seriesEntries: createDefaultEntitiesReducer('seriesEntries'),
    holdableItems: createDefaultEntitiesReducer('holdableItems'),
    mediaSummaries: createDefaultEntitiesReducer('mediaSummaries'),
    excerpts: createDefaultEntitiesReducer('excerpts'),
    events: createDefaultEntitiesReducer('events'),
    eventAudiences: createDefaultEntitiesReducer('eventAudiences'),
    eventTypes: createDefaultEntitiesReducer('eventTypes'),
    eventPrograms: createDefaultEntitiesReducer('eventPrograms'),
    eventLanguages: createDefaultEntitiesReducer('eventLanguages'),
    locations: createDefaultEntitiesReducer('locations'),
    places: createDefaultEntitiesReducer('places'),
    images: createDefaultEntitiesReducer('images'),
    cards: createDefaultEntitiesReducer('cards'),
    promos: createDefaultEntitiesReducer('promos'),
    marcFields: createDefaultEntitiesReducer('marcFields')
  })
);
